module.exports = __webpack_public_path__ + "img/journal2_TH.59233136.png";